import Home from './components/Home.vue'
import Empresa from './components/Empresa.vue'
import Institucional from './components/Institucional.vue'
import Contato from './components/Contato.vue'
import Categoria from './components/Categoria.vue'
import Busca from './components/Busca.vue'
import NotFoundView from './components/404.vue'

// Import Views - Dash
/*
import DashboardView from './components/views/Dashboard.vue'
import TablesView from './components/views/Tables.vue'
import TasksView from './components/views/Tasks.vue'
import SettingView from './components/views/Setting.vue'
import AccessView from './components/views/Access.vue'
import ServerView from './components/views/Server.vue'
import ReposView from './components/views/Repos.vue'
*/

// Routes
const routes = [
  {
    path: '/',
    component: Home,
    props: true
  },
  {
    path: '/empresa/:client_id',
    component: Empresa,
    props: true
  },
  {
    path: '/a-empresa',
    component: Institucional,
    props: true
  },
  {
    path: '/contato',
    component: Contato,
    props: true
  },
  {
    path: '/categoria/:category_id',
    component: Categoria,
    props: true
  },
  {
    path: '/busca',
    name: 'busca',
    component: Busca,
    props: true
  },
  {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes.js